export interface BlockOverlayData {
    category?: string;
    title?: string;
    message?: string;
    i18n?: Record<string, string>;
}

export interface AnnouncementData {
    id: string;
    message: string;
    backgroundColor?: string;
    textColor?: string;
}

export type ContentScriptOutboundMessage =
    | { kind: "register"; tabId: string; url: string; title: string }
    | { kind: "url-change"; tabId: string; url: string; title: string }
    | { kind: "title-change"; tabId: string; title: string }
    | { kind: "favicon-change"; tabId: string; favicon: string }
    | { kind: "text-input"; tabId: string; element: string; value: string }
    | { kind: "page-unload"; tabId: string }
    | { kind: "snapshot-report"; tabId: string; favicon?: string; active: boolean }
    | { kind: "overlay-event"; tabId: string; event: "block-dismissed" | "announce-dismissed" };

export type ControllerOutboundMessage =
    | { kind: "decision"; action: "allow" | "block"; data?: BlockOverlayData }
    | { kind: "show-announcement"; data: AnnouncementData }
    | { kind: "hide-announcement" }
    | { kind: "show-block-overlay"; data: BlockOverlayData }
    | { kind: "hide-block-overlay" }
    | { kind: "navigate"; url: string }
    | { kind: "close" }
    | { kind: "request-snapshot" };

export interface HandshakeMessage {
    kind: "handshake";
    protocolVersion: 1;
    tabId: string;
}

export const CONTROLLER_PROTOCOL_VERSION = 1;
